import Tab from '@mui/material/Tab';

export { Tab };
